import { Deserializable } from '../../protocols/deserializable';

export class ConfirmMemberRequest implements Deserializable {
  public email: string = '';
  public password: string = '';
  public eulaAccepted: boolean = false;

  constructor(email: string, password: string, eulaAccepted: boolean) {
    this.email = email;
    this.password = password;
    this.eulaAccepted = eulaAccepted;
  }

  onDeserialize = () => {};
}
